export function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-8 lg:py-12">
      <div className="text-center mb-12">
        <h1 className="text-3xl lg:text-4xl font-serif font-bold text-slate-900 tracking-tight mb-3">
          Privacy Policy
        </h1>
        <p className="text-sm text-slate-400">Last updated June 26, 2026</p>
      </div>

      <div className="space-y-8 text-slate-700">
        <section className="bg-white rounded-2xl p-6 lg:p-8 shadow-sm border border-indigo-50">
          <h2 className="text-lg font-bold text-slate-900 mb-3">What EventsCarousel is</h2>
          <p className="text-sm lg:text-base leading-relaxed text-slate-600">
            EventsCarousel ("we", "us") is a private, invite-only family archive app at eventscarousel.com.
            There are no public feeds — content is visible only to you and the people you explicitly
            invite or share with.
          </p>
        </section>

        <section className="bg-white rounded-2xl p-6 lg:p-8 shadow-sm border border-indigo-50">
          <h2 className="text-lg font-bold text-slate-900 mb-3">Information we collect</h2>
          <ul className="text-sm lg:text-base leading-relaxed text-slate-600 list-disc pl-5 space-y-2">
            <li><strong>Account information:</strong> your name and email address.</li>
            <li><strong>Content you upload:</strong> photos, voice recordings, event titles, descriptions, locations, and comments you choose to add to your archive.</li>
            <li><strong>Photo tagging data:</strong> if you use the optional face-tagging feature, facial descriptor data is generated from your photos to help match the same person across photos within your own account. This data is never shared outside your account and is not used for any purpose beyond helping you tag people in your own archive.</li>
            <li><strong>Account relationships:</strong> who you've invited as a member, viewer, or delegate, and what you've chosen to share with them.</li>
            <li><strong>Basic technical data:</strong> standard server logs (IP address, timestamps) for security and abuse prevention.</li>
          </ul>
        </section>

        <section className="bg-white rounded-2xl p-6 lg:p-8 shadow-sm border border-indigo-50">
          <h2 className="text-lg font-bold text-slate-900 mb-3">Device permissions</h2>
          <p className="text-sm lg:text-base leading-relaxed text-slate-600">
            The app requests access to your camera, microphone, and photo library only when you actively
            choose to take a photo, record audio, or upload media — and only to complete that action. We
            also support Face ID/Touch ID solely to protect access to the app on your device; no biometric
            data is ever transmitted to or stored on our servers.
          </p>
        </section>

        <section className="bg-white rounded-2xl p-6 lg:p-8 shadow-sm border border-indigo-50">
          <h2 className="text-lg font-bold text-slate-900 mb-3">How we use your information</h2>
          <p className="text-sm lg:text-base leading-relaxed text-slate-600">
            Solely to operate the app: storing and displaying your archive, enabling sharing with people
            you invite, authenticating your account, and sending account-related emails (such as invites
            and password resets). We do not sell your data, and we do not use it for advertising.
          </p>
        </section>

        <section className="bg-white rounded-2xl p-6 lg:p-8 shadow-sm border border-indigo-50">
          <h2 className="text-lg font-bold text-slate-900 mb-3">Sharing</h2>
          <p className="text-sm lg:text-base leading-relaxed text-slate-600">
            Your content is private by default. It is only visible to people you explicitly invite to your
            account (as members, viewers, or delegates) or to anyone you generate a public share link for —
            and you can revoke either at any time.
          </p>
        </section>

        <section className="bg-white rounded-2xl p-6 lg:p-8 shadow-sm border border-indigo-50">
          <h2 className="text-lg font-bold text-slate-900 mb-3">Data storage and deletion</h2>
          <p className="text-sm lg:text-base leading-relaxed text-slate-600">
            Photos and audio are stored on encrypted cloud storage; account data is stored in a managed
            database. You can delete individual photos, audio clips, or events at any time. To permanently
            delete your entire account and all associated data, go to Settings → Delete Account in the app.
            This is immediate and cannot be undone.
          </p>
        </section>

        <section className="bg-white rounded-2xl p-6 lg:p-8 shadow-sm border border-indigo-50">
          <h2 className="text-lg font-bold text-slate-900 mb-3">Contact</h2>
          <p className="text-sm lg:text-base leading-relaxed text-slate-600">
            Questions about this policy or your data? Email us at{' '}
            <a href="mailto:privacy@eventscarousel.com" className="text-indigo-600 hover:underline">
              privacy@eventscarousel.com
            </a>.
          </p>
        </section>
      </div>
    </div>
  );
}
